import React from 'react';
import classnames from 'classnames';

import Icon from '~/components/icon';
import {
  Countries,
  filterStateByCountry,
  type IStateObject,
  type StateCode } from
'~/services/actions/state-actions';

import OCButton from '../../../../button';

import styles from './styles/desktop-dropdown.module.css';

interface IProps {
  selectedState: StateCode;
  setSelectedState: (state: StateCode) => void;
  supportedStates: IStateObject[];
}

const DesktopStateDropdown: React.FC<IProps> = ({
  selectedState,
  setSelectedState,
  supportedStates
}) => {
  const isSingleColumn = supportedStates.length < 11;

  return (
    <div
      data-testid="desktop-states"
      className={classnames(
        styles.stateDropdown,
        isSingleColumn ? styles.singleColumn : ''
      )}>

			<div className={styles.cta}>
				{selectedState} <div className={styles.indicator}>&#x25BE;</div>
			</div>
			<div
        className={classnames(
          styles.states,
          isSingleColumn ? styles.singleColumn : ''
        )}>

				{[Countries.US, Countries.CANADA].map((country) => {
          const countryStates = supportedStates.filter(({ stateCode }) =>
          filterStateByCountry(stateCode, country)
          );

          if (!countryStates.length) {
            return null;
          }

          const tableCount = country == Countries.US ? 10 : 5;
          const columnCount = Math.ceil(countryStates.length / tableCount);
          const rowCount = Math.min(countryStates.length, tableCount);

          return (
            <React.Fragment key={country}>
							<div data-testid="country-title" className={styles.countryTitle}>
								{country}
							</div>
							<div
                style={{
                  gridTemplateColumns: `repeat(${columnCount}, ${435 / columnCount}px)`,
                  gridTemplateRows: `repeat(${rowCount}, 1fr)`
                }}
                className={styles.stateGrid}
                data-testid="state-grid">

								{countryStates.map((state) => {
                  return (
                    <OCButton
                      key={state.stateCode}
                      onClick={() => setSelectedState(state.stateCode)}
                      className={classnames(
                        styles.state,
                        state.stateCode === selectedState ?
                        styles.selected :
                        ''
                      )}>

											{state.stateName}
											<div className={styles.checkmark}>
												<Icon icon="Checkmark" fill="#00182e" />
											</div>
										</OCButton>);

                })}
							</div>
						</React.Fragment>);

        })}
			</div>
		</div>);

};

export default DesktopStateDropdown;